export default __webpack_public_path__ + "static/media/Omoike.3cd83bdd.png";